import { TextArea } from '@m/alchemy-ui/TextArea';
import { useIntl } from 'react-intl';
import { ErrorAlert, FieldsetGroup, Info, Item, Label, SrOnlyLegend } from './Onboard.styled';

interface BioProps {
  description?: string;
  error?: string;
}

const Bio = ({ description, error }: BioProps) => {
  const intl = useIntl();
  const errorMessage = error ?? '';
  return (
    <FieldsetGroup>
      <SrOnlyLegend>
        {intl.formatMessage({ id: 'profileInformation', defaultMessage: 'Profile Information' })}
      </SrOnlyLegend>
      <Item>
        <Label htmlFor="user_bio-onboard">{intl.formatMessage({ id: 'bio', defaultMessage: 'Bio' })}</Label>
        <TextArea
          name="user_bio"
          id="user_bio-onboard"
          aria-describedby="user-bio-info"
          defaultValue={description}
          isFullWidth
          minHeight="90px"
        />
        <Info id="user-bio-info">
          {intl.formatMessage({
            id: 'bioInfoText',
            defaultMessage: 'Tell others about yourself, your interests, and professional background'
          })}
        </Info>
        {errorMessage && <ErrorAlert>{errorMessage}</ErrorAlert>}
      </Item>
    </FieldsetGroup>
  );
};

export default Bio;
